import React from 'react';
import { checkPassword } from '../utils/passwordPolicy';

// The password rules under a new-password field, each ticking green as it is met — the web's
// counterpart of ParksphereMobileApp/components/PasswordChecklist.js (utils/passwordPolicy.js has
// the rules and the reasons). Unmet rules are a grey circle, not a red cross: half-way through
// typing is not a mistake. The server checks the same rules; this guides, it does not decide.
const listStyle = { listStyle: 'none', margin: '6px 0 0', padding: 0, fontSize: '0.85rem' };
const itemStyle = (met) => ({ display: 'flex', alignItems: 'center', gap: 6, padding: '1px 0', color: met ? '#2e7d32' : '#8b86a0' });

const Mark = ({ met }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    {met && <polyline points="8 12.5 11 15.5 16.5 9" />}
  </svg>
);

const PasswordChecklist = ({ password, username, email }) => {
  const { rules } = checkPassword(password || '', { username, email });
  return (
    <ul style={listStyle} aria-label="Password requirements">
      {rules.map((r) => (
        <li key={r.id} style={itemStyle(r.met)}>
          <Mark met={r.met} />
          <span>{r.label}</span>
          <span style={{ position: 'absolute', left: -9999 }}>{r.met ? '(met)' : '(not yet)'}</span>
        </li>
      ))}
    </ul>
  );
};

export default PasswordChecklist;
